import { render, staticRenderFns } from "./loadDetail.vue?vue&type=template&id=fa81e596&"
import script from "./loadDetail.vue?vue&type=script&lang=js&"
export * from "./loadDetail.vue?vue&type=script&lang=js&"
import style0 from "./loadDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports